import axios from "axios";
import { CALCULATE_URL } from "../constant";
import Moment from "moment";
const { decorate, observable, action } = require("mobx");

class Calculate {
  list = [];
  datelist = [];
  startDte;
  endDte;
  lastHisDate = Moment('1000-10-10');
  remain = 0;

  async getRemain() {
    //현재 잔액 조회
    try {
      let response = await axios.get(CALCULATE_URL+"/remain/?endDte="+Moment().hours('23').minutes('59').seconds('59'));
      let data = await response.data;

      this.remain = data[data.length-1].remain.toLocaleString('en').split(".")[0];;
    } catch (error) {
      throw error;
    }
  }

  async getList(startDt=Moment().date('01').hours('00').minutes('00').seconds('01'), endDt=Moment().hours('23').minutes('59').seconds('59')) {
    //조회
    try {
      this.isLoading = true;
      let response = await axios.get(CALCULATE_URL+"?startDt="+startDt+"&endDt="+endDt);
      let data = await response.data;
      this.datelist = [this.startDte, this.endDte];
      let strEx, strRe = '';
      
      data.map(e => {
        strEx = e.expense.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
        e.expense = strEx;
        
        strRe = Number(e.remain).toLocaleString('en').split(".")[0];
        // strRe = e.remain.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
        e.remain = strRe;
      });
      this.list = data;

      if(startDt !== Moment().date('01').hours('00').minutes('00').seconds('01')) {
        this.getRemain();
      }
      return data;
    } catch (error) {
      this.isLoading = false;
      throw error;
    }
  }

  async addCalculate(data) {
    //추가
    try {
      if(isFinite(data.expense.replace("+","").replace(",","")) === false) throw new Error('수입 및 지출 칸에는 숫자를 입력해주세요.');
      if(data.expense.includes('-')) 
        data.expense = data.expense.replace("-","");

      let response = await axios.post(CALCULATE_URL, {
        date: data.date,
        desc: data.desc,
        postscript: data.postscript,
        name: data.name,
        expense: data.expense,
      });
      
      await this.getList(this.datelist[0], this.datelist[1]);
      this.isLoading = false;
      return response;
    } catch (error) {
      
      throw error;
    }
  }

  async updateCalculate(data) {
    //수정
    try {
      if(data.expense.includes('-')) 
        data.expense = data.expense.replace("-","");

      let response = await axios.put(CALCULATE_URL, {
        data: data
      });
      await this.getList(this.startDte,this.endDte);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async deleteCalculate(id_) {
    //제거
    try {
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      let response = await axios.delete(
        CALCULATE_URL,
        {
          data: { id: id_ },
        },
        config
        );
        await this.getList(this.startDte,this.endDte);
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async setDate(startDt,endDt) {
    this.startDte = startDt
    this.endDte = endDt;
    await this.getList(startDt,endDt);
  }
  // async setCsv() {
  //   try {
  //     let response = await axios.get(CALCULATE_URL+"/excel?startDt="+this.startDt+"&endDt="+this.endDt);
  //     let data = await response.data;
  //     return data;
  //   } catch (error) {
  //     // this.isLoading = false;
  //     alert(error);
  //     throw error;
  //   }
  // }
  getDate() {
    return this.datelist;
  }

  async getTransfer(noEdit) {
    try{

      let response = await axios.get(CALCULATE_URL+"/transfer/?startDte="+noEdit);

      let data = await response.data;
      return data[0].remain;
    } catch(error) {
      return 0; //데이터가 없을 경우 이월금액
      throw error;
    }
  }

  getId() {
    const idlist = [this.list[0]._id, this.list[this.list.length-1]._id];
    return idlist;
  }

  async getLastHistory(id) {
    let response = await axios.get(CALCULATE_URL+"/lastid/?lastid="+id);
    let data = await response.data;
    this.lastHisDate = data[0].date;
  }
}

decorate(Calculate, {
  list: observable,
  startDte:observable,
  endDte:observable,
  lastHisDate: observable,
  remain:observable,
  setDate:action,
  getDate:action,
  getTransfer:action,
  getId:action,
  getLastHistory:action,
  getList: action,
  addCalculate: action,
  deleteCalculate: action,
  updateCalculate: action
});

const init = new Calculate();
export default init;
// GET: 조회 get
// POST: 등록 add
// PUT: 수정 update
// DELETE: 제거 delete
